'use client';

import { memo } from 'react';
import type { SearchResult } from '@/lib/search-client';

interface CommandPaletteResultItemProps {
  result: SearchResult;
  isActive: boolean;
  index: number;
  onSelect: (result: SearchResult) => void;
  onHover: (index: number) => void;
}

export const CommandPaletteResultItem = memo(function CommandPaletteResultItem({
  result,
  isActive,
  index,
  onSelect,
  onHover,
}: CommandPaletteResultItemProps) {
  return (
    <div
      id={`search-result-${index}`}
      role="option"
      aria-selected={isActive}
      data-active={isActive}
      tabIndex={-1}
      onClick={() => onSelect(result)}
      onMouseEnter={() => onHover(index)}
      className={`flex min-h-[44px] items-center gap-3 rounded-lg px-3 py-2 text-sm cursor-pointer transition-colors ${
        isActive
          ? 'bg-surface-hover text-text-primary'
          : 'text-text-secondary hover:bg-surface-hover hover:text-text-primary'
      }`}
    >
      <span className="shrink-0 text-base" aria-hidden="true">
        {result.icon}
      </span>
      <div className="min-w-0 flex-1">
        <div className="truncate font-medium">{result.title}</div>
        {result.sublabel && result.sublabel !== result.title && (
          <div className="truncate text-label text-text-dim">{result.sublabel}</div>
        )}
      </div>
      {result.countryFlag && (
        <span className="shrink-0 text-sm" aria-hidden="true">
          {result.countryFlag}
        </span>
      )}
    </div>
  );
}, (prev, next) => {
  // Only re-render if activation state or result identity changed
  return prev.isActive === next.isActive
    && prev.index === next.index
    && prev.result.href === next.result.href;
});
